<template>
    <div
        class="bg-AkBlack bg-black bg-opacity-50 fixed inset-0 z-10 flex items-center justify-center"
        v-if="value"
        @click.self="close"
    >
        <div class="relative">
            <template v-if="closeCross">
                <slot
                    v-if="'close' in $slots"
                    @click.native="close"
                    name="close"
                />
                <IconCross
                    v-else
                    :class="
                        closeCrossClass
                            ? closeCrossClass
                            : 'z-10 h-6 w-6 top-4 right-4'
                    "
                    class="absolute cursor-pointer"
                    @click.native="close"
                />
            </template>
            <slot />
        </div>
    </div>
</template>

<script>
import IconCross from './icons/IconCross.vue'

export default {
    name: 'Modal',
    components: { IconCross },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        closeCross: {
            type: Boolean,
            default: false,
        },
        closeCrossClass: {
            type: String,
            default: undefined,
        },
    },
    methods: {
        close() {
            this.$emit('input', false)
        },
    },
}
</script>
